import { render, staticRenderFns } from "./mapa_regiones.vue?vue&type=template&id=b9caa8ee&scoped=true"
import script from "./mapa_regiones.vue?vue&type=script&lang=js"
export * from "./mapa_regiones.vue?vue&type=script&lang=js"
import style0 from "./mapa_regiones.vue?vue&type=style&index=0&id=b9caa8ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9caa8ee",
  null
  
)

export default component.exports